"use client";

import type { PropsWithChildren } from 'react';
import { useRef } from 'react';

type Props = PropsWithChildren<{
  className?: string;
  disabled?: boolean;
  onPreview: () => void;
  clickDelayMs?: number;
  enabled?: boolean;
}>;

export const PreviewVideoOnClick = ({
  children,
  className,
  disabled,
  onPreview,
  clickDelayMs,
  enabled = true,
}: Props) => {
  const clickTimerRef = useRef<number | undefined>(undefined);

  const handleClick = () => {
    if (disabled || !enabled) return;
    try {
      if (clickTimerRef.current) {
        window.clearTimeout(clickTimerRef.current);
      }
      clickTimerRef.current = window.setTimeout(() => {
        clickTimerRef.current = undefined;
        onPreview();
      }, clickDelayMs ?? 250);
    } catch {}
  };

  const handleDoubleClick = () => {
    if (clickTimerRef.current) {
      window.clearTimeout(clickTimerRef.current);
      clickTimerRef.current = undefined;
    }
  };

  return (
    <div className={className} onClick={handleClick} onDoubleClick={handleDoubleClick}>
      {children}
    </div>
  );
};


